import React, { ReactElement } from 'react';
import { useParams } from 'react-router';
import { Link } from 'idsk-react-components';
import TypPripomienky from '../../../model/pripomienka/TypPripomienky';
import PripomienkaDetail from '../../../model/pripomienka/PripomienkaDetail';
import './pripomienkaDetailPagination.scss';
import routes from '../../../routing/routes';

interface Props {
  pripomienkaDetail: PripomienkaDetail,
}

const PripomienkaDetailPagination = ({
  pripomienkaDetail,
}: Props): ReactElement => {
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();

  const getNasledujucaPripomienkaDetailUrl = (): string => (pripomienkaDetail.typ === TypPripomienky.HROMADNA
    ? routes.hromadnePripomienky.detail.withParams(type, year, index, pripomienkaDetail.nasledujucaPripomienkaId)
    : routes.pripomienky.detail.withParams(type, year, index, pripomienkaDetail.nasledujucaPripomienkaId));

  const getPredchadzajucaPripomienkaDetailUrl = (): string => (pripomienkaDetail.typ === TypPripomienky.HROMADNA
    ? routes.hromadnePripomienky.detail.withParams(type, year, index, pripomienkaDetail.predchadzajucaPripomienkaId)
    : routes.pripomienky.detail.withParams(type, year, index, pripomienkaDetail.predchadzajucaPripomienkaId));

  const nasledujucaButton = (): ReactElement => (
    pripomienkaDetail?.nasledujucaPripomienkaId && (
      <Link
        className="next-detail-button"
        to={getNasledujucaPripomienkaDetailUrl()}
      >Nasledujúca pripomienka &gt;
      </Link>
    ));

  const predchadzajucaButton = (): ReactElement => (
    pripomienkaDetail?.predchadzajucaPripomienkaId && (
      <Link
        className="previous-detail-button"
        to={getPredchadzajucaPripomienkaDetailUrl()}
      >&lt; Predchádzajúca pripomienka
      </Link>
    ));

  return (pripomienkaDetail?.predchadzajucaPripomienkaId || pripomienkaDetail?.nasledujucaPripomienkaId) && (
    <div className="detail-pagination-buttons">
      {predchadzajucaButton()}
      {nasledujucaButton()}
    </div>
  );
};

export default PripomienkaDetailPagination;
